import React from 'react';
import Icon from '../../../components/AppIcon';

const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 })?.format(amount || 0);

const CustomerCard = ({ customer, onOpenDetail, onCreateBid, onCreateProject }) => {
  return (
    <div
      className="bg-card border border-border rounded-2xl p-4 active:scale-[0.98] transition-transform cursor-pointer"
      onClick={() => onOpenDetail(customer)}
    >
      {/* Header */}
      <div className="flex items-start gap-3 mb-3">
        <div className="w-11 h-11 rounded-xl bg-accent/10 flex items-center justify-center flex-shrink-0">
          <Icon name="Building2" size={22} className="text-accent" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-base font-semibold text-foreground truncate capitalize">
            {customer?.companyName || customer?.company_name}
          </h3>
          <p className="text-sm text-muted-foreground truncate capitalize">
            {customer?.contactPerson || customer?.contact_person}
          </p>
        </div>
        <Icon name="ChevronRight" size={18} className="text-muted-foreground flex-shrink-0 mt-0.5" />
      </div>
      {/* Stats row */}
      <div className="flex items-center gap-4 mb-3 py-2 border-y border-border/60">
        <div className="flex items-center gap-1.5">
          <Icon name="Briefcase" size={14} className="text-blue-500" />
          <span className="text-xs font-medium text-foreground">
            {customer?.activeProjects ?? customer?.active_projects ?? 0} Projects
          </span>
        </div>
        <div className="flex items-center gap-1.5">
          <Icon name="DollarSign" size={14} className="text-emerald-500" />
          <span className="text-xs font-medium text-foreground">
            {formatCurrency(customer?.totalValue ?? customer?.total_value)}
          </span>
        </div>
      </div>
      {/* Quick action buttons */}
      <div className="flex gap-2" onClick={e => e?.stopPropagation()}>
        <button
          onClick={() => onCreateBid(customer)}
          className="flex-1 flex items-center justify-center gap-1.5 bg-amber-500/10 text-amber-600 rounded-xl py-2.5 text-xs font-semibold min-h-[44px] active:bg-amber-500/20 transition-colors"
        >
          <Icon name="FileText" size={14} />
          Create Bid
        </button>
        <button
          onClick={() => onCreateProject(customer)}
          className="flex-1 flex items-center justify-center gap-1.5 bg-blue-500/10 text-blue-600 rounded-xl py-2.5 text-xs font-semibold min-h-[44px] active:bg-blue-500/20 transition-colors"
        >
          <Icon name="Briefcase" size={14} />
          Create Project
        </button>
      </div>
    </div>
  );
};

export default CustomerCard;
